import delve from 'dlv'
import React from 'react'
import { buildStaticPaths } from 'services/api'

import fetchSingleType from 'src/lib/Strapi/fetchSingleType'
import fetchAllSlugs from 'src/lib/Strapi/fetchAllSlugs'

import BlogNav from 'components/shared/BlogNav'
import UserBlogPost from 'src/components/shared/UserBlogPost'
import { SINGLES } from 'src/services/constants'

import { Seo, SeoProvider } from 'components/shared/Seo'
import fetchContentType from 'src/lib/Strapi/fetchContentType'
import spreadStrapiData from 'src/lib/Strapi/spreadStrapiData'

const User = ({ pageData, userBlogPosts }) => {
  const seo = {
    metaTitle: `${userBlogPosts?.[0]?.user?.data?.attributes?.username} | Open-Source Node.js Headless CMS`,
    metaDescription:
      userBlogPosts?.[0]?.user?.data?.attributes?.description ||
      `Browse the latest articles written by ${userBlogPosts?.[0]?.user?.data?.attributes?.username} | Open-Source Node.js Headless CMS`,
  }

  return (
    <div>
      <SeoProvider pageSeo={seo}>
        <Seo />
      </SeoProvider>
      <BlogNav
        categories={delve(pageData, 'blogPostNavCategories')}
        current={SINGLES.blog.url}
        newsletter={delve(pageData, 'newsletter')}
      />
      <UserBlogPost blogPosts={userBlogPosts} params={pageData.params} />
    </div>
  )
}

export async function getStaticPaths() {
  const data = await fetchAllSlugs('users')
  return buildStaticPaths(data, 'user')
}

export async function getStaticProps({ params, preview = null }) {
  const slug = params.slug

  let userBlogPosts = []
  try {
    userBlogPosts = await fetchContentType(
      'blog-posts',
      `filters[user][slug]=${slug}&pagination[start]=0&pagination[limit]=6&sort[0]=publishedAt:desc`
    )
    if (userBlogPosts.length === 0) {
      return {
        notFound: true,
      }
    }
  } catch (e) {
    console.log(e.toString())
  }

  const blogPostNav = await fetchSingleType(
    'blog-post-nav?populate=post_categories.post_sub_categories'
  )
  const blogPostNavCategories = spreadStrapiData(blogPostNav.post_categories)

  return {
    props: {
      pageData: {
        newsletter: delve(blogPostNav, 'newsletter') || null,
        blogPostNavCategories,
        params: `filters[user][slug]=${slug}&sort[0]=publishedAt:desc`,
      },
      userBlogPosts,
    },
  }
}

export default User
